import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiExclamationCircle({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3996 8.00059C14.3996 9.69797 13.7253 11.3258 12.5251 12.5261C11.3249 13.7263 9.697 14.4006 7.99961 14.4006C6.30222 14.4006 4.67436 13.7263 3.47413 12.5261C2.27389 11.3258 1.59961 9.69797 1.59961 8.00059C1.59961 6.3032 2.27389 4.67534 3.47413 3.4751C4.67436 2.27487 6.30222 1.60059 7.99961 1.60059C9.697 1.60059 11.3249 2.27487 12.5251 3.4751C13.7253 4.67534 14.3996 6.3032 14.3996 8.00059V8.00059ZM8.79961 11.2006C8.79961 11.4128 8.71532 11.6162 8.5653 11.7663C8.41527 11.9163 8.21178 12.0006 7.99961 12.0006C7.78744 12.0006 7.58395 11.9163 7.43392 11.7663C7.2839 11.6162 7.19961 11.4128 7.19961 11.2006C7.19961 10.9884 7.2839 10.7849 7.43392 10.6349C7.58395 10.4849 7.78744 10.4006 7.99961 10.4006C8.21178 10.4006 8.41527 10.4849 8.5653 10.6349C8.71532 10.7849 8.79961 10.9884 8.79961 11.2006V11.2006ZM7.99961 4.00059C7.78744 4.00059 7.58395 4.08487 7.43392 4.2349C7.2839 4.38493 7.19961 4.58841 7.19961 4.80059V8.00059C7.19961 8.21276 7.2839 8.41624 7.43392 8.56627C7.58395 8.7163 7.78744 8.80059 7.99961 8.80059C8.21178 8.80059 8.41527 8.7163 8.5653 8.56627C8.71532 8.41624 8.79961 8.21276 8.79961 8.00059V4.80059C8.79961 4.58841 8.71532 4.38493 8.5653 4.2349C8.41527 4.08487 8.21178 4.00059 7.99961 4.00059Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgHiExclamationCircle;
